/**
 * Preprocesses the content to unwrap our custom elements from `p` tags due to blackfriday's processing.
 */
export function preprocessContent(content: string) {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = content;

  const tagsToUnwrap = [
    "nw-section[stepid]",
    "nw-step",
    "nw-validation-box",
    "nw-validation-text",
    "nw-validation-url",
    "nw-validation-upload",
    "nw-variable",
  ];
  tagsToUnwrap.forEach(tag => {
    wrapper.querySelectorAll(`p ${tag}`).forEach(node => {
      const pTag = node.parentNode;
      if (pTag && pTag.parentNode) {
        // Move all children of the p tag (except nw-step) before the p tag
        while (pTag.firstChild && pTag.firstChild !== node) {
          pTag.parentNode.insertBefore(pTag.firstChild, pTag);
        }
        // Move the nw-step element (with its children) out of the p tag
        pTag.parentNode.insertBefore(node, pTag);
        // Move any remaining children of the p tag after the nw-step
        while (pTag.firstChild) {
          pTag.parentNode.insertBefore(pTag.firstChild, pTag.nextSibling);
        }
        // Remove the now-empty p tag
        pTag.parentNode.removeChild(pTag);
      }
    });
  });

  return wrapper.innerHTML;
}
